import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { ClientService } from '../../core/api/client.service';
import { environment } from '../../../environments/environment';
import { Provider } from '@supabase/supabase-js';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatCheckboxModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule],
  templateUrl: './registration.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './registration.component.css'
})
export class RegistrationComponent {
  private fb = inject(FormBuilder);
  private client = inject(ClientService);
  private translate = inject(TranslateService);

  registerForm: FormGroup;
  showConfirmation = false
  acceptedTerms = false
  errorMessage: string | null = null
  submitting = false

  constructor() {
    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.registerForm.invalid || this.submitting) return
    this.errorMessage = null;
    this.submitting = true;
    const { email, password } = this.registerForm.value;

    this.client.auth.signup(email, password).subscribe({
      next: () => {
        this.submitting = false;
        this.showConfirmation = true;
      },
      error: () => {
        this.submitting = false;
        this.showConfirmation = false;
        this.errorMessage = this.translate.instant('auth.errors.signup_failed');
      },
    });
  }

  async loginOauth(provider: Provider): Promise<void> {
    if (this.submitting) return;
    this.submitting = true;

    const { error } = await this.client.supabase.auth.signInWithOAuth({
      provider, options: {
        redirectTo: `${environment.url}/redirect`
      }
    });

    if (error) {
      this.submitting = false;
      this.errorMessage = this.translate.instant('auth.errors.oauth_failed');
    }
  }
}
